<template>
  <v-select
    id="temas-select"
    v-model="filter.contratos"
    item-text="numContrato"
    item-name="numContrato"
    item-value="numContrato"
    :items="contratos"
    label="Contratos"
    placeholder="Contratos"
    v-on:change="$emit('onChange', filter.contratos)"
    :disabled="disabled"
    :return-object="true"
    :loading="loading"
  >
    <template slot="no-data"> Nenhum Contrato </template>
  </v-select>
</template>

<script>
import { contratosAPI } from "@/apis";
import { mapActions } from "vuex";

export default {
  name: "ContratosPorUsuarioCombobox",
  props: {
    filter: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    user: { type: Number },
  },
  mounted() {
    this.load();
  },
  watch: {
    "user.usuarioId"(e) {
      console.log("🚀 ~ e:", e);

      this.load();
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    load() {
      this.contratos = [];
      this.loading = true;
      contratosAPI
        .listByUser(this.user)
        .then((resp) => {
          this.loading = false;
          this.contratos = resp.data;

          if (this.filter.contratoId)
            this.filter.contratos = this.contratos.find(
              (item) => item.contratoId == this.filter.contratoId
            );
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter Contratos");
        });
    },
  },
  data() {
    return {
      contratos: [],
      loading: false,
    };
  },
};
</script>

<style scoped>
.tema-eixo-combo {
  padding: 0 24px 20px;
}
</style>
